import { useEffect } from 'react';

const useUnmountAction = (action: () => void) => {
  useEffect(() => {
    return () => action();
  }, []);
};

export default useUnmountAction;
